export const content = {
  'website-title': {
    label: 'Website title',
    type: 'text',
    rules: ['required']
  }
}

export const design = {
  'background-color': {
    label: 'Background color',
    type: 'color-picker',
    rules: ['required', 'hex'],
    category: 'Colors'
  },
  'primary-color': {
    label: 'Primary color',
    type: 'color-picker',
    rules: ['required', 'hex'],
    category: 'Colors'
  },
  'secondary-color': {
    label: 'Secondary color',
    type: 'color-picker',
    rules: ['required', 'hex'],
    category: 'Colors'
  },
  'accent-color': {
    label: 'Accent color',
    type: 'color-picker',
    rules: ['required', 'hex'],
    category: 'Colors'
  },
  'text-dark-color': {
    label: 'Dark text color',
    type: 'color-picker',
    rules: ['required', 'hex'],
    category: 'Colors',
    hint: 'Color for dark text.'
  },
  'text-light-color': {
    label: 'Light text color',
    type: 'color-picker',
    rules: ['required', 'hex'],
    category: 'Colors',
    hint: 'Color for light text.'
  },
  'link-dark-color': {
    label: 'Dark link color',
    type: 'color-picker',
    rules: ['required', 'hex'],
    category: 'Colors',
    hint: 'Color for links on dark text.'
  },
  'link-light-color': {
    label: 'Light link color',
    type: 'color-picker',
    rules: ['required', 'hex'],
    category: 'Colors',
    hint: 'Color for links on light text.'
  },
  'text-color': {
    label: 'Default text color',
    type: 'radio',
    rules: ['required'],
    options: [
      { value: 'dark', text: 'Dark' },
      { value: 'light', text: 'Light' }
    ],
    category: 'Colors',
    hint:
      'Default color on all text. It is recommended to choose text color that fits the background color.'
  },
  'primary-text-color': {
    label: 'Primary text color',
    type: 'radio',
    rules: ['required'],
    options: [
      { value: 'dark', text: 'Dark' },
      { value: 'light', text: 'Light' }
    ],
    category: 'Colors',
    hint:
      'Default color on text under primary backgrounds. It is recommended to choose text color that fits the primary color.'
  },
  'secondary-text-color': {
    label: 'Secondary text color',
    type: 'radio',
    rules: ['required'],
    options: [
      { value: 'dark', text: 'Dark' },
      { value: 'light', text: 'Light' }
    ],
    category: 'Colors',
    hint:
      'Default color on text under secondary backgrounds. It is recommended to choose text color that fits the secondary color.'
  },
  'title-font-family': {
    label: 'Title font',
    type: 'google-fonts',
    rules: ['required'],
    category: 'Text'
  },
  'text-font-family': {
    label: 'Paragraph font',
    type: 'google-fonts',
    rules: ['required'],
    category: 'Text'
  },
  'title-font-weight': {
    label: 'Title font weight',
    type: 'radio',
    default: 'bold',
    options: [
      { value: '300', text: 'Light' },
      { value: 'normal', text: 'Normal' },
      { value: 'bold', text: 'Bold' }
    ],
    category: 'Text'
  },
  'text-font-weight': {
    label: 'Paragraph font weight',
    type: 'radio',
    default: 'normal',
    options: [
      { value: '300', text: 'Light' },
      { value: 'normal', text: 'Normal' },
      { value: 'bold', text: 'Bold' }
    ],
    category: 'Text'
  },
  'text-line-height': {
    label: 'Paragraph line height',
    type: 'slider',
    min: 1,
    max: 2,
    step: 0.1,
    suffix: 'em',
    default: 1.5,
    category: 'Text',
    hint: 'Default spacing on top and bottom of text.'
  },
  'title-line-height': {
    label: 'Title line height',
    type: 'slider',
    min: 1,
    max: 2,
    step: 0.1,
    suffix: 'em',
    default: 1.3,
    category: 'Text',
    hint: 'Default spacing on top and bottom of titles.'
  },
  'h1-font-size': {
    label: 'H1 font size',
    type: 'slider',
    min: 10,
    max: 100,
    suffix: 'px',
    default: '50px',
    category: 'Text'
  },
  'h2-font-size': {
    label: 'H2 font size',
    type: 'slider',
    min: 10,
    max: 100,
    suffix: 'px',
    default: '40px',
    category: 'Text'
  },
  'h3-font-size': {
    label: 'H3 font size',
    type: 'slider',
    min: 10,
    max: 100,
    suffix: 'px',
    default: '32px',
    category: 'Text'
  },
  'h4-font-size': {
    label: 'H4 font size',
    type: 'slider',
    min: 10,
    max: 100,
    suffix: 'px',
    default: '28px',
    category: 'Text'
  },
  'h5-font-size': {
    label: 'H5 font size',
    type: 'slider',
    min: 10,
    max: 100,
    suffix: 'px',
    default: '24px',
    category: 'Text'
  },
  'h6-font-size': {
    label: 'H6 font size',
    type: 'slider',
    min: 10,
    max: 100,
    suffix: 'px',
    default: '20px',
    category: 'Text'
  },
  'text-font-size': {
    label: 'Paragraph font size',
    type: 'slider',
    min: 10,
    max: 100,
    suffix: 'px',
    default: '16px',
    category: 'Text'
  },
  'link-underline': {
    label: 'Link underline',
    type: 'radio',
    options: [
      { value: 'none', text: 'No' },
      { value: 'underline', text: 'Yes' }
    ],
    default: 'underline',
    category: 'Text'
  },
  'horizontal-padding-button': {
    label: 'Horizontal padding for buttons',
    type: 'slider',
    min: 10,
    max: 50,
    suffix: 'px',
    default: '16px',
    category: 'Buttons',
    hint: 'Spacing on the left and right side of buttons.'
  },
  'vertical-padding-button': {
    label: 'Vertical padding for buttons',
    type: 'slider',
    min: 10,
    max: 50,
    suffix: 'px',
    default: '10px',
    category: 'Buttons',
    hint: 'Spacing on the top and bottom of buttons.'
  },
  'minimum-width-button': {
    label: 'Minimum width for buttons',
    type: 'slider',
    min: 50,
    max: 300,
    suffix: 'px',
    default: '64px',
    category: 'Buttons'
  },
  'border-radius-button': {
    label: 'Border radius for buttons',
    type: 'slider',
    min: 0,
    max: 50,
    suffix: 'px',
    default: '4px',
    category: 'Buttons',
    hint: 'Set the radius of the corners. This applies to buttons only.'
  },
  'section-padding': {
    label: 'Section padding',
    type: 'slider',
    min: 20,
    max: 150,
    suffix: 'px',
    default: '60px',
    category: 'General',
    hint:
      'Default spacing on top and bottom of sections. This can be adjusted individually by enabling custom padding via the "Edit section" panel.'
  },
  'column-spacing': {
    label: 'Column spacing',
    type: 'slider',
    min: 10,
    max: 50,
    suffix: 'px',
    default: '12px',
    category: 'General',
    hint: 'Spacing in between columns.'
  },
  'border-radius': {
    label: 'Border radius for rounded elements',
    type: 'slider',
    min: 1,
    max: 30,
    suffix: 'px',
    default: '4px',
    category: 'General',
    hint: 'Set the radius of the corners. This applies to all rounded elements.'
  }
}

export const layout = {}

export const advanced = {
  css: {
    label: 'Custom CSS',
    type: 'css-editor',
    hint: 'For advanced users only.'
  }
}

export default {
  content,
  design,
  layout,
  advanced
}
